import React from 'react';
import { pick } from 'js/utils/ramda.util';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../../store';
import { useExecuteAction } from '../../hooks/useExecuteAction';

import style from './RevokeScheduledBreak.scss';

export const RevokeScheduledBreak = ({ id, isInAccordion = false }) => {
    const translate = useComponentTranslations();
    const { isLoading, isActionsDisabled } = useDynamicReducerSelector(pick([
        'isLoading', 'isActionsDisabled'
    ]));
    const revokeScheduledBreak = useExecuteAction({ type: 'revoke', id });

    return isInAccordion
        ? (
            <Button
                type="button"
                view="primary"
                className={style.button}
                onClick={revokeScheduledBreak}
                disabled={isLoading || isActionsDisabled}
            >
                {translate('revoke')}
            </Button>
        ) : (
            <Icon
                type="close_svg"
                onClick={revokeScheduledBreak}
                aria-label={translate('aria-label.button.revoke')}
                className={`${style.icon} ${isLoading || isActionsDisabled ? style.disabled : ''}`}
            />
        );
};
